module.exports = __webpack_public_path__ + "media/images/log-out-bf4b22f50d077796bfa72797ce577ae4.svg";